import { isMealPlanMain, isMealPlanSideOrStaple } from 'common/MealPlanUtils';
import { MealPlanUpcomingOrderFragment } from 'src/gqlReactTypings.generated.d';

export const sortOrdersByMainsAndSides = (orders: MealPlanUpcomingOrderFragment[]) => {
  const ordersWithMains = orders.map((order) => {
    const lineItems = order.lineItems.filter(({ foodItem }) => isMealPlanMain(foodItem.mealPlanFoodType));
    return { ...order, lineItems };
  });
  const ordersWithSides = orders
    .map((order) => {
      const lineItems = order.lineItems.filter(({ foodItem }) => isMealPlanSideOrStaple(foodItem.mealPlanFoodType));
      return { ...order, lineItems };
    })
    .filter(({ lineItems }) => lineItems.length > 0);
  return { ordersWithSides, ordersWithMains };
};
